export const validatePlayer = (player, players) => {
    const {name, inGameNumber} = player;
    const isValidName = name ? !players.some(curPlayer => {
        return curPlayer.name === name
    }) : true
    const isValidInGameNumber = inGameNumber ? !players.some(curPlayer => {
        return curPlayer.inGameNumber === inGameNumber
    }) : true
    return isValidName && isValidInGameNumber
}